import * as Yup from "yup";

export const schema = Yup.object().shape({
  email: Yup.string().email("Некорректный Email").required("Введите Email"),
});
